import http from '../modules/http'

export default {
  install(Vue) {
    Object.assign(Vue.prototype, { $http: http })
  },
}
